module.exports = __webpack_public_path__ + "presenter3-2b35da1bf0fd7db4acfd052c3815a024.jpg";